@import "../../scss";

.root {
  width: 25rem;
  border-radius: 1.25rem;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  padding: var(--spacer-14) var(--spacer-4);
  background: var(--color-swamp-green);
  color: var(--color-cream);
  text-align: center;
  box-shadow: 0px 0px 20px 10px #00ff12, inset 0px 0px 6px 2px #00ff12;
}

.heading {
  @include typo--plant-card-plant-name;
  color: var(--color-bright-green);
  margin-bottom: var(--spacer-4);
}

.body {
  @include typo--discount-code-body;
  margin-bottom: var(--spacer-2);
}

.discount {
  @include typo--discount-code-body;
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: var(--spacer-4);
  display: inline-block;
  background: rgba(255, 247, 222, 0.15);
  border-radius: var(--spacer-1);
  padding: 4px 8px;
  user-select: all;
}

.cl {
  width: 35px;
  height: auto;
  position: absolute;
  top: var(--spacer-2);
  left: var(--spacer-2);
}

.ft {
  width: 36px;
  height: auto;
  position: absolute;
  top: var(--spacer-2);
  right: var(--spacer-2);
}

.ff {
  width: 36px;
  height: auto;
  position: absolute;
  bottom: var(--spacer-2);
  left: var(--spacer-2);
}

.cash {
  width: 21px;
  height: auto;
  position: absolute;
  bottom: var(--spacer-2);
  right: var(--spacer-2);
}

.confetti {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  pointer-events: none;
}
